'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselControl = function CarouselControl(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      direction = _ref.direction,
      large = _ref.large,
      hintText = _ref.hintText;
  return _react2.default.createElement(
    'a',
    {
      className: 'carousel-control',
      style: disabled ? { visibility: 'hidden' } : {},
      role: 'button',
      onClick: !disabled ? onClick : undefined },
    _react2.default.createElement('i', { className: 'fa' + (large ? ' fa-lg' : '') + ' fa-angle-' + direction, 'aria-hidden': 'true' }),
    _react2.default.createElement(
      'span',
      { className: 'sr-only' },
      hintText
    )
  );
};

CarouselControl.propTypes = {
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  direction: _propTypes2.default.oneOf(['up', 'down', 'left', 'right']),
  large: _propTypes2.default.bool,
  hintText: _propTypes2.default.string
};

exports.default = CarouselControl;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Carousel/CarouselControl.js
// module id = 429
// module chunks = 0